import type {
  CommunityPort,
  ContentPort,
  LocalAdapterSuite,
  NotificationsPort,
  StoragePort,
  TourPort,
} from '../domain/ports'
import { seedContentItems, seedFeedPosts, seedNotifications, tourShows } from '../fixtures'
import { LocalAuthAdapter } from './localAuthAdapter'
import { getBrowserStorage } from './memoryStorage'
import { LocalTicketAdapter } from './localTicketAdapter'

export class LocalTourAdapter implements TourPort {
  async loadShows() {
    return tourShows.map((show) => ({ ...show }))
  }
}

export class LocalCommunityAdapter implements CommunityPort {
  async loadPosts() {
    return seedFeedPosts.map((post) => ({ ...post }))
  }
}

export class LocalNotificationsAdapter implements NotificationsPort {
  async loadNotifications() {
    return seedNotifications.map((notification) => ({ ...notification }))
  }
}

export class LocalContentAdapter implements ContentPort {
  async loadContent() {
    return seedContentItems.map((item) => ({ ...item }))
  }
}

export const createLocalAdapterSuite = (storage: StoragePort = getBrowserStorage()): LocalAdapterSuite => {
  const tickets = new LocalTicketAdapter()
  return {
    auth: new LocalAuthAdapter({ storage }),
    tickets,
    tour: new LocalTourAdapter(),
    community: new LocalCommunityAdapter(),
    notifications: new LocalNotificationsAdapter(),
    content: new LocalContentAdapter(),
    setOnline(online: boolean) {
      tickets.setOnline(online)
    },
  }
}
